// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCO5ad6zgK1IY4jnuMLCg_m3KTl28ZlVgk",
  authDomain: "fotolio-799f4.firebaseapp.com",
  projectId: "fotolio-799f4",
  storageBucket: "fotolio-799f4.appspot.com",
  messagingSenderId: "81222658995",
  appId: "1:81222658995:web:7e158f00a9628850e979c6",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;
